import React, { useState, useEffect } from 'react';
import { Button } from './button';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  // Cookie-Consent Gültigkeitsdauer: 12 Monate (in Millisekunden)
  const CONSENT_DURATION = 365 * 24 * 60 * 60 * 1000; // 12 Monate

  useEffect(() => {
    // Prüfe, ob der Benutzer bereits eine Entscheidung getroffen hat
    const cookieConsentStr = localStorage.getItem('cookieConsent');
    
    if (!cookieConsentStr) {
      // Keine Entscheidung vorhanden - Banner anzeigen
      setIsVisible(true);
      return;
    }

    try {
      // Versuche, die Consent-Daten zu parsen (neues Format mit Zeitstempel)
      const consentData = JSON.parse(cookieConsentStr);
      
      // Prüfe, ob Consent abgelaufen ist (12 Monate)
      const consentAge = Date.now() - consentData.timestamp;
      
      if (consentAge < CONSENT_DURATION) {
        // Consent ist noch gültig - setze Google Analytics entsprechend
        if (window.gtag) {
          window.gtag('consent', 'update', {
            'analytics_storage': consentData.decision === 'accepted' ? 'granted' : 'denied'
          });
        }
        // Banner nicht anzeigen
        setIsVisible(false);
      } else {
        // Consent ist abgelaufen - Banner erneut anzeigen
        localStorage.removeItem('cookieConsent');
        setIsVisible(true);
      }
    } catch (e) {
      // Altes Format (nur String) - migriere zu neuem Format oder zeige Banner
      // Wenn es "accepted" oder "declined" ist, behalte die Entscheidung für diese Session
      if (cookieConsentStr === 'accepted' || cookieConsentStr === 'declined') {
        // Migriere zu neuem Format
        const consentData = {
          decision: cookieConsentStr,
          timestamp: Date.now()
        };
        localStorage.setItem('cookieConsent', JSON.stringify(consentData));
        
        // Setze Google Analytics entsprechend
        if (window.gtag) {
          window.gtag('consent', 'update', {
            'analytics_storage': cookieConsentStr === 'accepted' ? 'granted' : 'denied'
          });
        }
        setIsVisible(false);
      } else {
        // Unbekanntes Format - Banner anzeigen
        setIsVisible(true);
      }
    }
  }, []);

  const handleAccept = () => {
    const consentData = {
      decision: 'accepted',
      timestamp: Date.now()
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consentData));
    setIsVisible(false);
    
    // Google Analytics aktivieren
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }
  };

  const handleDecline = () => {
    const consentData = {
      decision: 'declined',
      timestamp: Date.now()
    };
    localStorage.setItem('cookieConsent', JSON.stringify(consentData));
    setIsVisible(false);
    
    // Google Analytics deaktivieren
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg p-4 md:p-6">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          <div className="flex-1">
            <h3 className="font-bold mb-2">Cookie-Einstellungen</h3>
            <p className="text-sm text-muted-foreground">
              Wir verwenden Cookies und ähnliche Technologien, um unsere Website zu analysieren und zu verbessern. 
              Insbesondere nutzen wir Google Analytics, um das Nutzerverhalten zu verstehen. 
              Durch Klicken auf "Akzeptieren" stimmen Sie der Verwendung von Cookies zu. 
              Weitere Informationen finden Sie in unserer{' '}
              <Link to="/legal" className="text-primary hover:underline">
                Datenschutzerklärung
              </Link>.
            </p>
          </div>
          <div className="flex gap-2 flex-shrink-0">
            <Button
              variant="outline"
              onClick={handleDecline}
              className="whitespace-nowrap"
            >
              Ablehnen
            </Button>
            <Button
              variant="default"
              onClick={handleAccept}
              className="whitespace-nowrap"
            >
              Akzeptieren
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
